import { IconPropsType } from '../types'

const ErrorIcon = ({ width = 106, height = 106 }: IconPropsType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 106 106'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='53' cy='53' r='53' fill='#D30B0B' fillOpacity='0.1' />
      <circle cx='53' cy='53' r='34.7812' fill='#D30B0B' />
      <path
        d='M61.2813 44.7188L44.7188 61.2813M44.7188 44.7188L61.2813 61.2813'
        stroke='white'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default ErrorIcon
